module.exports = __webpack_public_path__ + "img/8.06e16ba3.jpg";